import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=48bcb28c&scoped=true&"
import script from "./recharge.vue?vue&type=script&lang=js&"
export * from "./recharge.vue?vue&type=script&lang=js&"
import style0 from "./recharge.vue?vue&type=style&index=0&id=48bcb28c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcb28c",
  null
  
)

export default component.exports